// src/routes/ProductRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

// Product Components
import ProductListPage from '../pages/products/ProductListPage';
import CreateProductPage from '../pages/products/CreateProductPage';
import BulkProductImportPage from '../pages/products/BulkProductImportPage';
import ManageProductAttributesPage from '../pages/products/ManageProductAttributesPage';
import ManageProductCategoriesPage from '../pages/products/ManageProductCategoriesPage';
import ManageProductTagsPage from '../pages/products/ManageProductTagsPage';
import ManageProductBrandsPage from '../pages/products/ManageProductBrandsPage';
import EditProductPage from '../pages/products/EditProductPage';
import ProductDetailsPage from '../pages/products/ProductDetailsPage';

const ProductRoutes = () => {
  return (
    <Routes>
      {/* Product List */}
      <Route 
        path="/" 
        element={
          <PermissionRoute requiredPermission="view_all_products">
            <ProductListPage />
          </PermissionRoute>
        } 
      />
      
      {/* Create Product */}
      <Route 
        path="/create" 
        element={
          <PermissionRoute requiredPermission="create_product">
            <CreateProductPage />
          </PermissionRoute>
        } 
      />
      
      {/* Product Categories */}
      <Route 
        path="/categories" 
        element={
          <PermissionRoute requiredPermission="view_all_product_categories">
            <ManageProductCategoriesPage />
          </PermissionRoute>
        } 
      />
      
      {/* Product Attributes */}
      <Route 
        path="/attributes" 
        element={
          <PermissionRoute requiredPermission="view_all_product_attributes">
            <ManageProductAttributesPage />
          </PermissionRoute>
        } 
      />
      
      {/* Product Tags */}
      <Route 
        path="/tags" 
        element={
          <PermissionRoute requiredPermission="view_all_product_tags">
            <ManageProductTagsPage />
          </PermissionRoute>
        } 
      />
      
      {/* Product Brands */}
      <Route 
        path="/brands" 
        element={
          <PermissionRoute requiredPermission="view_all_product_brands">
            <ManageProductBrandsPage />
          </PermissionRoute>
        } 
      />
      
      {/* Bulk Import Products */}
      <Route
        path="/bulk-import"
        element={
          <PermissionRoute requiredPermission="create_product">
            <BulkProductImportPage />
          </PermissionRoute>
        }
      />

      {/* Edit Product */}
      <Route
        path="/:productId/edit"
        element={
          <PermissionRoute requiredPermission="edit_product">
            <EditProductPage />
          </PermissionRoute>
        } 
      />
      
      {/* Product Details */}
      <Route 
        path="/:productId" 
        element={
          <PermissionRoute requiredPermission="view_all_products">
            <ProductDetailsPage />
          </PermissionRoute>
        } 
      />
    </Routes>
  );
};

export default ProductRoutes;